module.exports = __webpack_public_path__ + "img/entrance_plant_4@2x.eb8345b2.jpg";